import React from 'react';
import './loading.css';

function Loading() {
  return (
    <div className='load-page'>
      <div className='loader'>
        <div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loading;
